import { render, staticRenderFns } from "./googleSlidePresenting.vue?vue&type=template&id=361e2b18&scoped=true&"
import script from "./googleSlidePresenting.vue?vue&type=script&lang=js&"
export * from "./googleSlidePresenting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e2b18",
  null
  
)

export default component.exports